import React, { useState } from "react";
import { useTheme } from "@mui/material/styles";
import {
  Box,
  Typography,
  Avatar,
  Card,
  CardContent,
  Grid,
  Divider,
  Tab,
  Tabs,
  Paper,
} from "@mui/material";
import { Link } from "react-router-dom";

const vereadoresItens = [
  { label: "Ver Todos", to: "/vereadores/vertodos" },
  { label: "Cris Azevedo", to: "/vereadores/crisazevedo" },
  { label: "Edilmo Lira", to: "/vereadores/edilmolira" },
  { label: "Erivan Elias", to: "/vereadores/erivanelias" },
  { label: "Jailson Mendonça", to: "/vereadores/jailsonmendonca" },
  { label: "Janaína Bezerra", to: "/vereadores/janainabezerra" },
  { label: "Leandro da Ótica", to: "/vereadores/leandrodaotica" },
  { label: "Novinho de Dinarte", to: "/vereadores/novinhodedinarte" },
  { label: "Professor Júnior", to: "/vereadores/professorjunior" },
  { label: "Tabelinho da Ambulância", to: "/vereadores/tabelinhodaambulancia" },
];

const Vereadores = () => {
  const theme = useTheme();
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newIndex) => {
    setTabIndex(newIndex);
  };

  return (
    <Box sx={{ padding: 4, maxWidth: 1200, margin: "0 auto" }}>
      <Box
        sx={{
          backgroundColor: theme.palette.primary.main,
          color: "#fff",
          padding: 2,
          borderRadius: 1,
          marginBottom: 2,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          VEREADORES
        </Typography>
      </Box>

      <Divider sx={{ marginY: 4 }} />

      <Paper square>
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          sx={{ borderBottom: 1, borderColor: "divider" }}
        >
          {vereadoresItens.map((vereador, index) => (
            <Tab key={index} label={vereador.label} component={Link} to={vereador.to} />
          ))}
        </Tabs>
      </Paper>

      <Grid container spacing={2} sx={{ marginTop: 4 }}>
        {vereadoresItens.slice(1).map((vereador, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card sx={{ borderRadius: 2 }}>
              <CardContent sx={{ display: "flex", alignItems: "center" }}>
                <Avatar
                  src="/path-to-avatar.jpg"
                  alt={vereador.label}
                  sx={{ width: 64, height: 64, marginRight: 2 }}
                />
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: "bold", textTransform: "uppercase" }}>
                    {vereador.label}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    Vereador(a)
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Vereadores;